import type { UploadRequestOption } from 'rc-upload/lib/interface';
import { RcFile } from 'antd/lib/upload';
import * as querystring from 'querystring';
import { ConnectionType } from '@sezenta/connection';

export default class S3FileUploader {
  fileUrls: Record<string, string> = {};
  constructor(
    private readonly connection: ConnectionType,
    private readonly setLoading: (loading: boolean) => void,
  ) {}

  getUrl = (uid: string) => {
    return this.fileUrls[uid];
  };

  upload = (info: UploadRequestOption) => {
    const handle = async () => {
      try {
        this.setLoading(true);
        const file = info.file as RcFile;
        const response = await this.connection.post('files/pre-signed-url', {
          fileName: file.name,
          mimeType: file.type,
          mask: false,
        });
        const value = response.data;
        const urlPath = value.upload.substring(0, value.upload.indexOf('?'));
        const query = value.upload.substring(value.upload.indexOf('?') + 1);
        const url: any = querystring.parse(query);
        this.fileUrls[file.uid] = value.download;
        const xhr = new XMLHttpRequest();
        const awsSecurityToken = url['x-amz-security-token'];
        delete url['x-amz-security-token'];
        xhr.open('PUT', `${urlPath}?${querystring.encode(url)}`, true);
        if (awsSecurityToken) {
          xhr.setRequestHeader('x-amz-security-token', awsSecurityToken);
        }
        xhr.onprogress = (e) => {
          console.log('ONPROGRESS');
          // info.onProgress({ percent: (e.loaded / e.total) * 100 });
          info.onProgress?.(e);
        };
        xhr.onabort = () => {
          console.log('ONABRT');
          info.onError?.(new Error('aborted'), undefined);
          this.setLoading(false);
        };
        xhr.onerror = () => {
          console.log('ONERR');
          info.onError?.(new Error('error'), undefined);
          this.setLoading(false);
        };

        xhr.onloadstart = () => {
          console.log('ONSTART');
          const evt: any = new ProgressEvent('Upload');
          evt.progress = 0;
          info.onProgress?.(evt);
        };
        xhr.onload = (event) => {
          console.log('ONLOAD', event);
          if (xhr.status === 200) {
            console.log('ONSUCCESS', event);
            info.onSuccess?.(event, xhr);
            this.setLoading(false);
          } else {
            info.onError?.(new Error(`error ${xhr.status}`));
            this.setLoading(false);
          }
        };
        xhr.setRequestHeader('Content-Type', file.type);
        xhr.send(file);
      } catch (e) {
        console.error(e);
        info.onError?.(new Error(`error uploading file`));
        this.setLoading(false);
      }
    };
    handle();
  };
}
